import { Howl } from 'howler';

export const sounds = {
  whoosh:    new Howl({ src: [require('@/assets/sounds/simple-whoosh-382724.mp3')] }),
  click:     new Howl({ src: [require('@/assets/sounds/click-345983.mp3')] }),
  laser:     new Howl({ src: [require('@/assets/sounds/laser-104024.mp3')] }),
  get_ready: new Howl({ src: [require('@/assets/sounds/get_ready.mp3')] }),
  win_sound: new Howl({ src: [require('@/assets/sounds/win_sound.mp3')] }),
  lose_sound:new Howl({ src: [require('@/assets/sounds/lose_sound.mp3')] }),
  bgm:       new Howl({
               src: [require('@/assets/sounds/activity1.mp3')],
               loop: true,
               volume: 0.5
             }),
  bgm_frames: new Howl({
               src: [require('@/assets/sounds/activity3.mp3')],
               loop: true,
               volume: 0.5
             }),
  photo_shutter: new Howl({ src: [require('@/assets/sounds/photo_shutter.mp3')] }),
  bgm_bodymove: new Howl({
               src: [require('@/assets/sounds/activity4.mp3')],
               loop: true,
               volume: 0.5
             }),
  got_one: new Howl({ src: [require('@/assets/sounds/got_one.mp3')] }),
  food_game: new Howl({
               src: [require('@/assets/sounds/food_game.mp3')],
               loop: true,
               volume: 0.5
             }),
  start_sound: new Howl({ src: [require('@/assets/sounds/start-sound.mp3')] }),
  score_sound: new Howl({ src: [require('@/assets/sounds/score-sound.mp3')] }),
  wrong_sound: new Howl({ src: [require('@/assets/sounds/wrong_sound.mp3')] }),
  ambient3: new Howl({
  src: [require('@/assets/sounds/ambient3.mp3')],
  loop: true,
  volume: 0.5
}),
  desert_shimmer: new Howl({
               src: [require('@/assets/sounds/desert-shimmer-24684.mp3')],
               loop: true,
               volume: 0.5
             }),
  magic: new Howl({ src: [require('@/assets/sounds/magic.mp3')] }),
  drums_for_games_extended: new Howl({
               src: [require('@/assets/sounds/drums_for_games_extended.mp3')],
               loop: true,
               volume: 0.5
             }),
  are_you_ready_brian: new Howl({ src: [require('@/assets/sounds/are_you_ready_brian.mp3')] }),
  greenpatch: new Howl({ src: [require('@/assets/sounds/greanpatch.mp3')] }),
  cyber_town: new Howl({
    src: [require('@/assets/sounds/cyber-town-simcity-style-music-22907.mp3')],
    loop: true,
    volume: 0.5
  }),
  mainTheme: new Howl({
    src: [require('@/assets/sounds/main_theme.mp3')],
    loop: true
  }),
  settings_menu: new Howl({
    src: [require('@/assets/sounds/settings_menu.mp3')],
    loop: true
  }),
  buttonClick: new Howl({
    src: [require('@/assets/sounds/click-345983.mp3')]
  }),
  click_sun: {
    morning: new Howl({ src: [require('@/assets/sounds/shine-9-268911.mp3')], volume: 0.5 }),
    noon: new Howl({ src: [require('@/assets/sounds/shine-10-268906.mp3')], volume: 0.5 }),
    afternoon: new Howl({ src: [require('@/assets/sounds/shine-11-268907.mp3')], volume: 0.5 }),
    night: new Howl({ src: [require('@/assets/sounds/shine-5-268908.mp3')], volume: 0.5 })
  },
};